<app-card-loading></app-card-loading>
<app-top-menu></app-top-menu>
<div class="pt-2" class="container-app">
  <router-outlet></router-outlet>
  <div style="height: 50px !important;"></div>
</div>
<div id="help-btn" (click)="redirect()" class="button_helpProblem">
  <span class="text_helpProblem">Dúvidas ou Problemas <b>?</b></span>
  <span class="icon_helpProblem">?</span>
</div>
